<template>
    <div>
        <div class="form-group_up">
            <label class="form-label" for="name-f">
                {{__t('SEARCH')}}
            </label>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text  border-right-0">
                        <i class="fal fa-democrat"></i>
                    </span>
                </div>

                <input type="text" v-model="search_param"  id="filter_search" class="form-control" :placeholder="__t('SEARCH')">

                <div class="input-group-append srch">
                    <button class="btn btn-primary shadow-0 waves-effect waves-themed" v-on:click="send_search">
                        <i class="fal fa-search"></i>
                    </button>
                    <button
                        v-on:click="show_filter"
                        type="button" class="btn btn-outline-primary shadow-0 waves-effect waves-themed">
                        {{__t('ADVANCED_FILTER')}}
                    </button>
                    <button type="button" class="btn btn-danger shadow-0  waves-effect waves-themed" v-on:click="clear_form">
                        <span class="fal fa-times mr-1"></span>
                        {{__t("CLEAN_FILTER")}}
                    </button>

                </div>
            </div>
            <span class="help-block">  {{__t('SEARCH_HELPER')}}</span>
        </div>

        <div class="collapse show" id="imc_filter" style="" v-if="is_show_filter">
            <div class="form-group js-stools-container-filters">
                <div class="d-flex flex-wrap ">

                    <div class="flex-fill mt-2 mb-2">

                        <imc_select
                            filter_name="rest_id"
                            hidden_input="org_inp"
                            send_trigger_name="filter_order_select_change"
                            items_url="internal/v1/catalog/restaurants"
                            active_filed_name="title"
                            active_filed_val="id"
                            :placeholder="__t('REST_FILTER')"
                            :active_id="this.active_org"
                        ></imc_select>

                    </div>

                    <div class="flex-fill mt-2 mb-2">

                        <imc_select
                            filter_name="provider_id"
                            hidden_input="provider_inp"
                            send_trigger_name="filter_order_select_change"
                            items_url="internal/providers/out"
                            active_filed_name="name"
                            active_filed_val="id"
                            :placeholder="__t('PROVIDER_FILTER')"
                            :active_id="this.active_provider"
                        ></imc_select>

                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import Imc_select from "../../sys/xml_fields/imc_select";

const {mapFields} = createHelpers({
	getterType: 'orders/getOrdersStateField',
	mutationType: 'orders/updateOrdersStateField',
});

export default {
	name: "filter_head",
    components: {Imc_select},
	data() {
		return {
            search_param : "",
            active_org : null,
            active_provider : null,

			is_load: false,
            is_active_filter : false,
			search_txt : "",
			rows : [],
            restaurants : [],
		}
	},

	created () {
		this.search_txt = this.search_param;

	},

	mounted()  {

	},

	methods: {


		clear_form() {
			EventBus.$emit('clean_orders_filter');
		},

		send_search() {
			EventBus.$emit('search_orders_called',this.search_param);
		},


        show_filter () {
            this.is_active_filter = !this.is_active_filter;
        },

	},

	computed: {
        is_show_filter() {
            if(this.active_org > 0) {
                return true;
            }

            return this.is_active_filter;
        },

        /*
		...mapFields([
			'list',
			'pagination',
			'send_list',
			'all_filter',
			'filter'
		]),

        active_org() {
            if (this.all_filter.hasOwnProperty('rest_id')) {
                return parseInt(this.all_filter.rest_id);
            }
            return 0;
        },

        active_provider() {
            if (this.all_filter.hasOwnProperty('provider_id')) {
                return parseInt(this.all_filter.provider_id);
            }
            return 0;
        },



		search_param : {
			get: function () {
				if(this.all_filter.hasOwnProperty('search')) {
					if( this.all_filter.search == null) {
						return "";
					}
					return this.all_filter.search;
				}
			},
			set: function (newValue) {
				this.search_txt = newValue;
			}
		},*/

	}
}
</script>

<style scoped>

</style>
